import { render, staticRenderFns } from "./loading-bar.svg.vue?vue&type=template&id=06f98570&scoped=true&"
import script from "./loading-bar.svg.vue?vue&type=script&lang=js&"
export * from "./loading-bar.svg.vue?vue&type=script&lang=js&"
import style0 from "./loading-bar.svg.vue?vue&type=style&index=0&id=06f98570&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f98570",
  null
  
)

export default component.exports